






























import VueOptions from '@utils/VueOptions'

settings =
  name: 'TagSelector'

  vue:
    props: ['value', 'tags', 'options']

    data: ->
      newTag: null
      selectedKeys: @value || []

    computed:
      filteredTags: ->
        @tags.filter((tag) => tag.value not in @selectedKeys)

      placeholder: ->
        @options?.placeholder || 'New tag'

      limit: ->
        @options?.limit || Infinity

      featuredTags: ->
        @options?.featuredTags || []

      formatter: ->
        @options?.formatter || 'formatTitle'

    methods:
      hiRemoveTag: (tag) ->
        @selectedKeys.splice @selectedKeys.indexOf(tag), 1
        @inputChanged()

      hiAddTag: (tag) ->
        @selectedKeys.push tag
        @inputChanged()
        @newTag = null

      inputChanged: ->
        @$emit 'input', @selectedKeys

      formatTag: (key) ->
        tag = @tags.find((tag) => tag.value is key)
        @$options.filters[@formatter](tag.label)

      isFeatured: (key) ->
        key in @featuredTags

    watch:
      value: (v) ->
        @selectedKeys = v

export default VueOptions.vue settings
